import styled from 'styled-components'
import { Box } from '@material-ui/core'

export const ProgramInfo = styled(Box)`
  height: auto;
`
